import { getAPI, postAPI } from "../../api/api"
import { REACT_APP_JOB, REACT_APP_CANDIDATEFILTER , REACT_APP_CUSTOMERSETTINGS, REACT_APP_JOBFILTER} from "../../utils/common"
// import { postAPIa } from "../../api/test"

export async function getPositions(searchValue : string , page : number, pageSize: number, data?: any){    
    const Details = postAPI(   REACT_APP_JOBFILTER+ `/position-filter?search=${searchValue}&page=${page}&size=${pageSize}`, data)
    return Details
}

export async function getPositionsCount(loginId: any, body: any) {
    const Details = postAPI( REACT_APP_CUSTOMERSETTINGS + `/recruiter-dashboard-position-count/${loginId}`, body) 
    return Details
}

export async function getChartData(loginId:any) {
    const Details = getAPI( REACT_APP_CUSTOMERSETTINGS + `/recruiter-dashboard-chart-counts/${loginId}`) 
    return Details
}

export async function getCandidates(tabName: string, pageSize: number, pageNumber: number, searchValue: string, filters?: any) {
   
    const Details = postAPI( REACT_APP_CANDIDATEFILTER + `/candidate-filter?page=${pageNumber}&size=${pageSize}&tab=${tabName}&search=${searchValue}`, filters)
        return Details
    
}